import styled from 'styled-components';

import { colors, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const StyledInStudioEditToolbar = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${spacing.plusHalf};
`;

export const Controls = styled.div`
  display: flex;
  gap: ${spacing.half};
  margin-right: ${spacing.half};
  > div {
    flex: 1 1 auto;
    display: inline-flex;
    align-self: stretch;
  }
  button {
    height: 100%;
  }
`;

export const LoadingContainer = styled.div`
  height: ${pxToRem(300)};
  border: 1px solid ${colors.grey15};
  border-radius: ${spacing.quarter};
`;

export const PreviewPaneContainer = styled.div`
  > :first-child {
    min-width: 0;
  }
`;
